import style from "./MarqueeText.module.css";

function MarqueeText({
	text = "",
	className = "",
	separator = "··",
	maxChars = 30,
	pxPerSecond = 80,
}) {
	const safeText = text ?? "";
	const overflows = safeText.length > maxChars;
	const truncated = overflows
		? safeText.slice(0, maxChars).trimEnd() + "..."
		: safeText;

	// Roughly: how long to scroll one full copy + separator across the viewport.
	// Approximate one character as ~8px, plus a small floor so very short
	// overflowing strings don't fly past.
	const approxWidth = safeText.length * 8 + 40;
	const duration = Math.max(3, approxWidth / pxPerSecond);

	return (
		<div
			className={`${style.container} ${className} ${
				overflows ? style.canScroll : ""
			}`}
			style={{ "--marquee-duration": `${duration}s` }}
		>
			<span className={style.truncated}>{truncated}</span>
			{overflows && (
				<span className={style.track} aria-hidden="true">
					<span className={style.copy}>{safeText}</span>
					<span className={style.sep}>{separator}</span>
					<span className={style.copy}>{safeText}</span>
					<span className={style.sep}>{separator}</span>
				</span>
			)}
		</div>
	);
}

export default MarqueeText;
